<template>
  <fragment>
    <class-header
      :subname="lecture.category"
      :name="lecture.lecName"
      v-bind:menus="menus"
      v-bind:buttons="buttons"
      v-bind:mainmenuOpened="true"
      v-bind:sysmenuActive="false"
      :icon="lecture.lecIcon?lecture.lecIcon.atchFileId:''"
    ></class-header>

    <section ref="container" class="container">
      <!-- side menus -->
      <common-side-menu :menus="side_menus"></common-side-menu>
      <!-- //end .side-nav -->
      <div class="container-fiuld clearfix">
        <div class="btn-group-box clearfix">
          <div class="btn-group pull-left clearfix">
            <div class="input-group w140 pull-left round m-r-5" style="margin-top: 1px;">
              <span class="input-group-addon v-mid">
                <select class="form-control round-left" v-model="newStatus">
                  <option value>== 상태 일괄변경 ==</option>
                  <option value="신청">신청</option>
                  <option value="승인">승인</option>
                  <option value="취소">취소</option>
                  <option value="반려">반려</option>
                </select>
              </span>
              <span class="input-group-addon v-mid" style="width:50px;">
                <button
                  @click="changeStatusAll"
                  class="btn bg-deepblue full-width text-white p-r-5 p-l-5 round-right"
                  style="margin-top: -1px;"
                >일괄변경</button>
              </span>
            </div>
            <div class="select pull-left m-r-5">
              <a class="btn round" @click="mail">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="v-mid m-r-5"
                  width="22"
                  height="20"
                  viewBox="0 0 22 20"
                >
                  <path
                    class="msg-i"
                    d="M262.519,1266.28a0.158,0.158,0,0,0,.019.08c0,0.02.019,0.06,0.019,0.08a0.473,0.473,0,0,1,.019.08,0.3,0.3,0,0,1,.038.08c0.019,0.02.019,0.04,0.038,0.06a0.107,0.107,0,0,1,.038.06l0.057,0.06,0.019,0.02a0.019,0.019,0,0,1,.019.02,0.447,0.447,0,0,0,.209.12,0.037,0.037,0,0,1,.038.02,0.91,0.91,0,0,0,.228.04h20.5a0.91,0.91,0,0,0,.228-0.04,0.037,0.037,0,0,0,.038-0.02,2.043,2.043,0,0,0,.209-0.12,0.019,0.019,0,0,0,.019-0.02l0.019-.02,0.057-.06a0.107,0.107,0,0,0,.038-0.06c0.019-.02.019-0.04,0.038-0.06a0.3,0.3,0,0,0,.038-0.08,0.1,0.1,0,0,0,.019-0.08c0-.02.019-0.06,0.019-0.08a0.473,0.473,0,0,0,.019-0.08v-18.46a0.792,0.792,0,0,0-.779-0.82H263.279a0.792,0.792,0,0,0-.779.82v18.38A0.1,0.1,0,0,1,262.519,1266.28Zm2.432-.94,5.756-7.25,2.394,1.76a0.752,0.752,0,0,0,.874,0l2.394-1.76,5.756,7.25H264.951Zm18.067-1.44-5.377-6.75,5.358-3.94v10.69h0.019Zm-18.96-15.26H283v2.58l-9.461,6.95-9.48-6.95v-2.58Zm0,4.57,5.357,3.94-5.357,6.75v-10.69Z"
                    transform="translate(-262.5 -1247)"
                  />
                </svg> 전자우편 보내기
              </a>
            </div>
            <div class="select pull-left m-r-5">
              <a class="btn round" @click="sms">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="v-mid m-r-5"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <path
                    class="sms-i"
                    d="M386.428,1249.93a10,10,0,0,1,14.807,13.41,3.719,3.719,0,0,0,1.575,1.82,0.933,0.933,0,0,1-.268,1.76,5.3,5.3,0,0,1-.708.05h0a6.478,6.478,0,0,1-3.6-1.16A10,10,0,0,1,386.428,1249.93Zm0.8,13.34a8.909,8.909,0,0,0,10.763,1.38,0.59,0.59,0,0,1,.285-0.08,0.621,0.621,0,0,1,.348.11,5.414,5.414,0,0,0,3.138,1.16,5.789,5.789,0,0,1-1.714-2.37,0.561,0.561,0,0,1,.1-0.6A8.871,8.871,0,1,0,387.229,1263.27Zm2.082-9.57h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1253.7Zm0,2.73h8.38a0.569,0.569,0,0,1,.565.57,0.561,0.561,0,0,1-.565.56h-8.38a0.562,0.562,0,0,1-.566-0.56A0.573,0.573,0,0,1,389.311,1256.43Zm0,2.74h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1259.17Z"
                    transform="translate(-383.5 -1247)"
                  />
                </svg> 문자 보내기
              </a>
            </div>
          </div>
          <!-- //end .btn-group -->

          <div class="btn-group pull-right clearfix">
            <div class="search-box pull-left w200 m-r-5">
              <input
                id="search"
                class="form-control round full-width m-b-0"
                type="text"
                v-model="keyword"
                @keydown.enter="refresh"
              />
              <label
                for="search"
                style="width:30px;height:30px;background-size: 20px auto;"
                @click="refresh"
              >검색</label>
            </div>
            <div class="select pull-left m-r-5">
              <a class="btn round pull-left">
                <img class="v-mid m-r-5" src="images/x.png" alt /> 전체 다운로드
              </a>
            </div>
          </div>
          <!-- //end .btn-group -->
        </div>
        <!-- //end .btn-group-box -->

        <table class="table2 table-hover m-t-10 text-center">
          <thead>
            <tr class="bg-lightgray">
              <th>
                <input
                  id="table-allcheck"
                  class="checkbox"
                  type="checkbox"
                  ref="checkAll"
                  @change="checkAll"
                />
                <label for="table-allcheck">체크버튼</label>
              </th>
              <th>신청일</th>
              <th>신청자</th>
              <th>강의기간</th>
              <th>수강인원</th>
              <th colspan="2">강사배정</th>
              <th>신청관리</th>
              <th></th>
            </tr>
          </thead>
          <tbody
            v-for="(item,idx) in list"
            :item="item"
            :index="idx"
            :key="'classroom-apply-list-'+idx+'-'+hash(item)"
          >
            <tr class="margin">
              <td colspan="8"></td>
            </tr>
            <tr>
              <td>
                <input
                  :id="'classroom-item-idx-'+idx"
                  class="checkbox"
                  type="checkbox"
                  v-model="item.checked_"
                  @change="checkOne"
                />
                <label :for="'classroom-item-idx-'+idx">체크버튼</label>
              </td>
              <td>{{item.regDate | parseRegDate}}</td>

              <td class="text-left">{{item.mberName}} ({{item.mberId}})</td>
              <td v-if="lecture.eduPeriodType=='교육일 지정'">
                {{lecture.lecEduDateList[0].eduStartDate | parseRegDate}}
                <br />
                ~
                {{lecture.lecEduDateList[0].eduEndDate | parseRegDate}}
                <br />
              </td>
              <td v-if="lecture.eduPeriodType=='수강생 신청'">
                {{item.regDate | parseRegDate}}
                <br />
                ~
                {{item.regDate+(1000*60*60*24*lecture.eduDay) | parseRegDate}}
                <br />
                ({{lecture.eduDay}}일)
              </td>
              <td v-if="lecture.eduPeriodType=='일정 선택'">
                {{item.applEduDateList[0].eduStartDate | parseRegDate}}
                <br />
                ~
                {{item.applEduDateList[item.applEduDateList.length-1].eduStartDate | parseRegDate}}
                <br />
                ({{item.applEduDateList.length}}회차)
              </td>

              <td>{{lecture.lesTargetType=='개인수강생'?'개인':(item.applInfoList.filter(e=>e.itemName=='수강인원'||e.itemName=='참가인원').length?item.applInfoList.filter(e=>e.itemName=='수강인원'||e.itemName=='참가인원')[0].itemValue:'알 수 없음')}}</td>
              <td>{{lecture.instAllotType=='신청 후 배정'?(item.applEduList.length?item.applEduList[0].mberName:''):(lecture.eduList.length?lecture.eduList[0].mberName:"")}}</td>
              <td>
                {{lecture.instAllotType}}
                <button
                  v-show="lecture.instAllotType=='신청 후 배정'"
                  class="btn-sm round"
                  @click="openSetTeacherModal(item)"
                >강사배정</button>
              </td>
              <td>
                <!-- 찾아가는 국어문화학교는 아래 select를 사용합니다 -->
                <select
                  class="form-control-sm full-width m-b-0 round"
                  v-model="item.applStatus"
                  @change="changeStatus(item)"
                >
                  <option value="신청">신청</option>
                  <option value="승인">승인</option>
                  <option value="취소">취소</option>
                  <option value="반려">반려</option>
                </select>
              </td>
              <td>
                <div class="see-more">
                  <a @click="openSubMenu(idx)($event)">
                    <img src="images/see-more.png" width="5" alt />
                  </a>
                  <ul :class="{on:subMenuIndex === idx}">
                    <li @click="openApplyDetailModal(item)">신청상세</li>
                    <li @click="deleteAppl(item.applId)">삭제</li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <modal-apply-detail
      :config="modals.ModalApplyDetail"
      :key="hash(modals.ModalApplyDetail)"
      @close="modals.ModalApplyDetail.show=false"
    ></modal-apply-detail>

    <ModalAssignTeacher
      @close="modals.ModalAssignTeacher.show=false;"
      @assign="assign"
      @sendEmail="sendEmail"
      :config="modals.ModalAssignTeacher"
      :key="hash(modals.ModalAssignTeacher)"
    ></ModalAssignTeacher>
    <modal-email
      :config="modals.ModalEmail"
      @close="modals.ModalEmail.show=false;"
      :key="hash(modals.ModalEmail)"
      @onDone="onDone"
      @onConfirm="onConfirm"
    ></modal-email>
    <modal-sms
      :config="modals.ModalSms"
      @close="modals.ModalSms.show=false;"
      :key="hash(modals.ModalSms)"
      @onDone="onDone"
      @onConfirm="onConfirm"
    ></modal-sms>
    <modal-confirm
      :config="modals.ModalConfirm"
      :key="'modal-confirm-'+hash(modals.ModalConfirm)"
      @no="modals.ModalConfirm.show=false"
    ></modal-confirm>
    <modal-alert
      :config="modals.ModalAlert"
      @close="modals.ModalAlert.show=false;"
      :key="hash(modals.ModalAlert)"
    ></modal-alert>

    <common-footer></common-footer>
  </fragment>
</template>

<script>
import fnAdjustHeight from "../mixins/fnAdjustHeight.js";
import fnUserList from "../mixins/fnUserList";

import ClassHeader from "../components/ClassHeader.vue";
import CommonFooter from "../components/CommonFooter.vue";
import CommonSideMenu from "../components/CommonSideMenu.vue";
import ModalConfirm from "../modals/ModalConfirm.vue";
import ModalAlert from "../modals/ModalAlert.vue";
import ModalEmail from "../modals/ModalEmail.vue";
import ModalSms from "../modals/ModalSms.vue";
import ModalAssignTeacher from "../modals/ModalAssignTeacher";
import ModalApplyDetail from "../modals/ModalApplyDetail.vue";

import axios from "axios";
import server from "../statics/server.js";
import moment from "moment";

export default {
  // 컴포넌트 명
  name: "ViewClassroomApplyList",
  mixins: [fnAdjustHeight, fnUserList],
  // 이 컴포넌트에서 사용할 자식컴포넌트 목록
  components: {
    ClassHeader,
    CommonFooter,
    CommonSideMenu,
    ModalConfirm,
    ModalAlert,
    ModalEmail,
    ModalSms,
    ModalAssignTeacher,
    ModalApplyDetail
  },

  mounted: function() {
    axios
      .post(
        server.addr() + server.api.LECTURE + "/" + this.$route.params.lecId,
        {}
      )
      .then(response => {
        this.lecture = response.data.return;
        this.refresh();
        if (this.lecture.classroomOpt.indexOf("출결") == -1)
          this.menus.splice(
            this.menus.indexOf(this.menus.find(e => e.name == "출결")),
            1
          );
        if (this.lecture.classroomOpt.indexOf("과제") == -1)
          this.menus.splice(
            this.menus.indexOf(this.menus.find(e => e.name == "과제")),
            1
          );
        if (this.lecture.classroomOpt.indexOf("설문") == -1)
          this.menus.splice(
            this.menus.indexOf(this.menus.find(e => e.name == "설문")),
            1
          );
        if (this.lecture.classroomOpt.indexOf("시험") == -1)
          this.menus.splice(
            this.menus.indexOf(this.menus.find(e => e.name == "시험")),
            1
          );
        //if(this.lecture.classroomOpt.indexOf("동영상 등록")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='강의 목차')), 1 );
      });
  },

  // 이 컴포넌트에서 내부적으로 사용할 데이터
  data: function() {
    return {
      menus: [
        {
          name: "강의 목차",
          link: "/classroom/" + this.$route.params.lecId + "/curriculum",
          selected: false
        },
        {
          name: "수강관리",
          link: "/classroom/" + this.$route.params.lecId + "/apply",
          selected: true
        },
        {
          name: "출결",
          link: "/classroom/" + this.$route.params.lecId + "/attendance",
          selected: false
        },
        {
          name: "시험",
          link: "/classroom/" + this.$route.params.lecId + "/exam",
          selected: false
        },
        {
          name: "과제",
          link: "/classroom/" + this.$route.params.lecId + "/assignment",
          selected: false
        },
        {
          name: "설문",
          link: "/classroom/" + this.$route.params.lecId + "/survey",
          selected: false
        },
        {
          name: "게시판",
          link: "/classroom/" + this.$route.params.lecId + "/board",
          selected: false
        }
      ],
      side_menus: [
        // 사이드 메뉴
        {
          name: "수강 신청 관리",
          link: "/classroom/" + this.$route.params.lecId + "/apply",
          selected: true
        },
        {
          name: "수강현황 관리",
          link: "/classroom/" + this.$route.params.lecId + "/progress",
          selected: false
        }
      ],
      side_buttons: [],
      buttons: [],
      modals: {
        ModalConfirm: ModalConfirm.default(),
        ModalAlert: ModalAlert.default(),
        ModalEmail: ModalEmail.default(),
        ModalSms: ModalSms.default(),
        ModalAssignTeacher: ModalAssignTeacher.default(),
        ModalApplyDetail: ModalApplyDetail.default()
      },
      subMenuIndex: -1,
      list: [],
      lecture: {},
      keyword: "",
      orderBy: "CODE_91_APPL.REG_DATE DESC",
      newStatus: ""
    };
  },

  // 이 컴포넌트에서 내부적으로 사용할 메써드
  methods: {
    refresh: function() {
      axios
        .post(server.addr() + server.api.APPL, {
          lecId: this.$route.params.lecId,
          keyword: this.keyword,
          orderBy: this.orderBy
        })
        .then(response => {
          this.list = response.data.list.map(e => {
            e.checked_ = false;
            return e;
          });
        });
    },
    openSubMenu: function(index) {
      return event => {
        event.stopPropagation();
        if (index === this.subMenuIndex) {
          this.subMenuIndex = -1;
        } else this.subMenuIndex = index;
      };
    },
    checkOne: function() {
      if (this.list.find(e => !e.checked_)) {
        this.$refs.checkAll.checked = false;
      } else {
        this.$refs.checkAll.checked = true;
      }
    },
    checkAll: function() {
      if (this.$refs.checkAll.checked) {
        this.list.forEach(e => (e.checked_ = true));
      } else {
        this.list.forEach(e => (e.checked_ = false));
      }
    },
    changeStatus: function(item) {
      axios
        .patch(server.addr() + server.api.APPL + "/" + item.applId, {
          applStatus: item.applStatus
        })
        .then(() => {
          this.refresh();
        });
    },
    changeStatusAll: function() {
      if (this.newStatus == "") {
        this.modals.ModalAlert.msg = "적용 할 상태를 선택하세요.";
        this.modals.ModalAlert.show = true;
        return;
      }
      let targets = this.list.filter(e => e.checked_);
      if (targets.length == 0) {
        this.modals.ModalAlert.msg = "적용 할 수강 신청건을 선택하세요.";
        this.modals.ModalAlert.show = true;
        return;
      }
      axios
        .patch(
          server.addr() + server.api.APPL,
          this.list
            .filter(e => e.checked_)
            .map(e => {
              return { applId: e.applId, applStatus: this.newStatus };
            })
        )
        .then(() => {
          this.refresh();
        });
    },
    mail: function() {
      let targets = this.list.filter(a => a.checked_);
      if (targets.length == 0) {
        this.modals.ModalAlert.msg = "전자우편을 수신할 대상을 선택하세요.";
        this.modals.ModalAlert.show = true;
        return;
      }
      targets = targets.map(t => t.mber);
      this.onMailForm(false, targets);
    },
    sms: function() {
      let targets = this.list.filter(a => a.checked_);
      if (targets.length == 0) {
        this.modals.ModalAlert.msg = "문자를 수신할 대상을 선택하세요.";
        this.modals.ModalAlert.show = true;
        return;
      }
      targets = targets.map(t => t.mber);
      this.onSMSForm(false, targets);
    },
    openSetTeacherModal: function(item) {
      this.modals.ModalAssignTeacher.applId = item.applId;
      this.modals.ModalAssignTeacher.show = true;
    },
    openApplyDetailModal: function(appl) {
      this.modals.ModalApplyDetail.appl_info = appl;
      this.modals.ModalApplyDetail.show = true;
    },
    assign: function(teachers) {
      axios
        .patch(
          server.addr() + server.api.APPL_EDU,
          teachers.map(t => {
            return {
              applId: this.modals.ModalAssignTeacher.applId,
              mberId: t.mberId,
              mberName: t.mberName
            };
          })
        )
        .then(response => {
          response;
          this.refresh();
          this.modals.ModalAssignTeacher.show = false;
        });
    },
    sendEmail: function(mber) {
      this.onMailForm(false, [mber]);
    },
    deleteAppl: function(applId) {
      this.modals.ModalConfirm.msg = "수강 신청을 정말 삭제하시겠습니까?";
      this.modals.ModalConfirm.btnYes.name = "삭제";
      this.modals.ModalConfirm.btnYes.fn = () => {
        axios
          .delete(server.addr() + server.api.APPL + "/" + applId)
          .then(response => {
            response;
            this.refresh();
            this.modals.ModalConfirm.show = false;
          });
      };
      this.modals.ModalConfirm.show = true;
    }
  },

  filters: {
    parseRegDate(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  }
};
</script>
<style scope>
.msg-i {
  fill: #fff;
  fill-rule: evenodd;
}
.sms-i {
  fill: #fff;
  fill-rule: evenodd;
}
.see-more > ul.on {
  display: block;
}
</style>
